import { render, staticRenderFns } from "./ChannelHeroArtCmp.vue?vue&type=template&id=042cfb41&scoped=true&"
import script from "./ChannelHeroArtCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelHeroArtCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelHeroArtCmp.vue?vue&type=style&index=0&id=042cfb41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042cfb41",
  null
  
)

export default component.exports